// shared/src/schemas/signal-outcome.ts
// Zod schema for `signal_outcomes` table (DDL: 0001_init.sql:226-241 + ALTER ADDs
// in 0002_phase-12.2-calibration.sql:113-118 - DROP drift_at_50pct_horizon via 0003).
// Net column count: 9 base + 7 ADD - 1 DROP = 15 cols (matches schema-vs-ddl test).
// Adds the missing Zod guard called out by audit-r3 S-002.

import { z } from 'zod';

export const SignalOutcomeHorizonEnum     = z.enum(['1d', '5d', '10d', '20d', '60d', '90d']);
export const SignalOutcomeKindEnum        = z.enum(['correct', 'incorrect', 'neutral']);
export const SignalOutcomeCloseSourceEnum = z.enum(['daily_closes', 'intraday_fallback', 'manual_correction']);

export const SignalOutcomeSchema = z.object({
  id:                      z.string(),
  signal_id:               z.string(),
  horizon:                 SignalOutcomeHorizonEnum,
  realized_price:          z.number().positive(),
  outcome:                 SignalOutcomeKindEnum,
  realized_at:             z.string().datetime(),
  scored_at:               z.string().datetime(),
  scorer_version:          z.string(),
  close_source:            SignalOutcomeCloseSourceEnum,
  // 0002 ADD COLUMNs (nullable — calibration backfill may not populate all).
  hit_conf_price:          z.number().int().nullable(),
  hit_inv_price_first:     z.number().int().nullable(),
  days_to_conf_price:      z.number().int().nullable(),
  days_to_inv_price:       z.number().int().nullable(),
  magnitude_actual_pct:    z.number().nullable(),
  timing_classification:   z.string().nullable(),
});

export type SignalOutcomeRow = z.infer<typeof SignalOutcomeSchema>;
